var map = {
	"./de": 11489,
	"./de.js": 11489,
	"./en-gb": 53615,
	"./en-gb.js": 53615,
	"./es": 37726,
	"./es.js": 37726,
	"./fr": 1670,
	"./fr.js": 1670,
	"./it": 23099,
	"./it.js": 23099,
	"./pt": 34774,
	"./pt.js": 34774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35358;